/** This component is visible in UI when we try to combine two query in query builder screen */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { ValidatedTextInput } from '@els/els-react--text-input';
import { useDispatch } from 'react-redux';
import { ButtonWithIcon } from '@els/els-react--button';
import { updateGroupTitleAction } from '../../QueryletActions';

/** This component is visible in UI when we try to combine two query in query builder screen */
function GroupTitle({ groupTitle, nodelist }) {
  const [editMode, setEditMode] = useState(false);

  const [title, setTitle] = useState(groupTitle.groupName);
  const groupNameRef = useRef(null);

  const dispatch = useDispatch();
  const ariaText = !editMode ? 'Edit Group Name' : 'Update Group Name';
  const alphanumeric = /^[a-zA-Z0-9 ]+$/;

  const renameGroup = (titleVal) => {
    setTitle(titleVal || title);
    setEditMode(!editMode);
    if (groupNameRef.current) {
      groupNameRef.current.focus();
    }
    if (!title || title?.trim().length < 3 || title?.trim().length > 20 || !alphanumeric.test(title.trim())) {
      setEditMode(true);
    } else if (editMode) {
      dispatch(updateGroupTitleAction(groupTitle, title, nodelist));
    }
  };

  return (
    <div className="ql__prop__title ql__prop__group-title">
      {!editMode ? (
        <span className="cursor-move">
          {title.length > 12 ? (
            <Flyout
              className="patent-content__processing-mode-flyout"
              flyout={title}
              shouldCloseOnESC
              placement="top-start"
              trigger="hover"
              pointerType="primary">
              <button type="button" className="ql__prop--name text-flyout u-els-anchorize" aria-label={`${title}`}>
                {title}
              </button>
            </Flyout>
          ) : (
            <span className="ql__prop--name" aria-label={title}>
              {title}
            </span>
          )}
        </span>
      ) : (
        <ValidatedTextInput
          value={title}
          inputRef={groupNameRef}
          onlyValidateWhenTouched
          label={title}
          min={3}
          max={20}
          shouldHideLabel
          required
          className="ql__prop__group-title__input"
          onChange={(e) => setTitle(e?.target?.value)}
        />
      )}
      <Flyout trigger="hover" flyout={editMode ? 'Save' : 'Edit group name'} placement="bottom" theme="simple">
        <ButtonWithIcon
          sprite={editMode ? 'Checkmark' : 'Edit'}
          type="link"
          id="querybuilder-update-groupname"
          iconOnly
          onClick={() => {
            renameGroup();
          }}>
          {ariaText}
        </ButtonWithIcon>
      </Flyout>
    </div>
  );
}

GroupTitle.propTypes = {
  groupTitle: PropTypes.object,
  nodelist: PropTypes.array,
};
export default GroupTitle;
